import { Box, Typography } from '@mui/material';

import { useTranslatedText } from 'hooks/useTranslatedText';
import { TransferTicketFragment } from 'types/api/tickets.types';

import BorderStack from 'components/@common/BorderStack';
import SeatingInfoGroup from 'components/@tickets/SeatingInfoGroup';
import TicketQuantityIcon from 'components/@tickets/TicketQuantityIcon';

interface Props {
  ticket: TransferTicketFragment;
}

const TransferTicket = ({ ticket }: Props) => {
  const translate = useTranslatedText();

  return (
    <BorderStack
      sx={{
        display: 'flex',
        p: 0,
      }}
      key={ticket.id}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          p: 2,
          alignItems: 'center',
        }}
      >
        <TicketQuantityIcon />
        <Box
          sx={{
            flex: 1,
          }}
        >
          <Typography
            variant="small"
            sx={{
              fontWeight: 'bold',
              color: 'grey.200',
            }}
          >
            {translate(ticket.name)}
          </Typography>
        </Box>
      </Box>
      <SeatingInfoGroup bookObjectsInfo={ticket.bookedInfo} />
    </BorderStack>
  );
};

export default TransferTicket;
